import React, {PropTypes} from 'react';
import classnames from 'classnames';

const BoxesRow = ({ children }) => (
    <div className="boxRow">
        {children}
    </div>);

export default BoxesRow;